import {
    ClipboardCheck,
    Sparkles,
    Zap,
    Layers2,
    Users,
    Brush
} from "lucide-react";
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";

export const features = [
    {
        icon: <Sparkles className="w-6 h-6" />,
        iconBg: "bg-blue-100",
        iconColor: "text-[#4949DE]",
        title: "100% photo consistency across all cards",
    },
    {
        icon: <Zap className="w-6 h-6" />,
        iconBg: "bg-blue-100",
        iconColor: "text-[#4949DE]",
        title: "Faster ID generation — no retakes",
    },
    {
        icon: <Layers2 className="w-6 h-6" />,
        iconBg: "bg-blue-100",
        iconColor: "text-[#4949DE]",
        title: "Dual-purpose: attendance + fees",
    },
    {
        icon: <Users className="w-6 h-6" />,
        iconBg: "bg-blue-100",
        iconColor: "text-[#4949DE]",
        title: "Works for students, staff, and parents",
    },
    {
        icon: <Brush className="w-6 h-6" />,
        iconBg: "bg-blue-100",
        iconColor: "text-[#4949DE]",
        title: "Modern, clean, AI-verified look",
    },
    {
        icon: <ClipboardCheck className="w-6 h-6" />,
        iconBg: "bg-blue-100",
        iconColor: "text-[#4949DE]",
        title: "Easy real-time tracking and records",
    }
];


export default function WhySchoolLoveAiPowredIdCard() {

    return (
        <Box
            badge={"Why us"}
            title={"Why schools love AI-ID Cards"}
            leftBlock={
                <div className='col-span-2 md:col-span-1'>
                    <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
                        {features.map((member, index) => <MarktingCard key={"WhySchoolLoveAiPowredIdCard" + index} member={member} />)}
                    </div>
                </div>
            }
        />
    );
}